import { gql } from '@apollo/client';

export const GET_GAME_GQL = gql`
  query GetGame($id: ID!) {
    getGame(id: $id) {
      _id
      description
      title
      uri
      category
      type
      is_template
      config {
        assets {
          type
          uri
        }
        elements {
          _id
          uri
          type
          sub_type
          position
          rotation
          scale
          color
          background_color
          text
          thumbnail
          opacity
          curv_x
          curv_y
          auto_play
          cta_uri
        }
        scene {
          background_color
          view_axis
        }
        screens {
          type
          position
          user_info {
            name
            type
            is_required
            label
            style
            country_code
            uri
          }
          elements {
            uri
            type
            position
            rotation
            scale
            color
            background_color
            text
            thumbnail
            height
            width
            border_radius
            border_width
            border_style
            border_color
            opacity
            event
          }
        }
        timer
      }
    }
  }
`;

export const GET_GAME_META_TAGS_GQL = gql`
  query getGameMetaTags($id: ID!) {
    getGameMetaTags(id: $id) {
      title
      description
      thumbnail
      favicon
    }
  }
`;
